<template>
  <div id="product-list">
    <div class="product-list">
      <ul class='products'>
        <li v-bind:key="product_index" v-for="(product,product_index) in products"
            v-bind:class="{ 'matched': true,
                            'bike' : true,
                            'kind-f': product.gender == 'F',
                            'kind-m': product.gender == 'M',
                            'kind-k': product.gender == 'K'}">
          <item :product="product"/>
        </li>
      </ul><!-- product -->
    </div>
  </div>
</template>

<script>

import Item from './Item'
import _ from 'lodash'

export default {
  name: 'series-bikes-list',
  components: {
    Item
  },
  props: {
    series: String
  },

  created: function () {
    let prods = _.filter(window.env.data.bikes, {'group_name': this.series});

    // sortujemy po product.position z bazy przekazanemu w DataController jako sort_order

      this.products = _.orderBy(prods,function (a) {
        return parseInt(a.sort_order);
      },'desc');

  },
  data () {
    return {
      products: {}
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Products/SeriesBikesList.vue